import { ArrayValue } from '@coveo/bueno';
import { requiredNonEmptyString, validatePayload, } from '../../../utils/validate-payload.js';
import { makeAnalyticsAction, } from '../../analytics/analytics-utils.js';
import { SearchPageEvents } from '../../analytics/search-action-cause.js';
import { facetIdDefinition } from '../generic/facet-actions-validation.js';
const categoryFacetBreadcrumbPayloadDefinition = {
    categoryFacetId: facetIdDefinition,
    categoryFacetPath: new ArrayValue({
        required: true,
        each: requiredNonEmptyString,
    }),
};
const getCategoryFacetMetadata = (state, { categoryFacetId, categoryFacetPath, }) => {
    const facet = state.categoryFacetSet[categoryFacetId];
    const categoryFacetField = facet?.request.field;
    const categoryFacetTitle = `${categoryFacetField}_${categoryFacetId}`;
    return {
        categoryFacetId,
        categoryFacetPath,
        categoryFacetField,
        categoryFacetTitle,
    };
};
//TODO: KIT-2859
export const logCategoryFacetBreadcrumb = (payload) => makeAnalyticsAction('analytics/categoryFacet/breadcrumb', (client, state) => {
    validatePayload(payload, categoryFacetBreadcrumbPayloadDefinition);
    return client.makeBreadcrumbFacet(getCategoryFacetMetadata(state, payload));
});
export const categoryBreadcrumbFacet = () => ({
    actionCause: SearchPageEvents.breadcrumbFacet,
});
